export class TrackSession {
    pKey: number;
    time: string = "";
    maxSpeed: number = 0;
    avgSpeed: number = 0;
    sumDistance: number = 0;
    steps: number = 0;
    synced: boolean = false;
    startPlace: string;
    startDate: Date = new Date();
    activityType: number = 0;
}


// WEBPACK FOOTER //
// /src/models/TrackSession.ts